import React, { useContext } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { SecondaryButton, PrimaryButton } from "../buttons";
import Modal from "../Modal";
import Text from "../edu/Text";
import { FormContext } from "../../context/form-context";

import "./FormDirtyWarningModal.scss";

const FormDirtyWarningModal = ({
  unSavedModalShown = false,
  hideTrackerModals = () => {},
  showPreviousModal = () => {}
}) => {
  const { t } = useTranslation();
  const formContext = useContext(FormContext);

  const clearDirty = () => {
    formContext.notDirty();
    formContext.setValues({});
    hideTrackerModals();
  };

  return (
    <Modal
      isOpen={unSavedModalShown}
      showCloseButton={false}
      onRequestClose={clearDirty}
    >
      <h5 className="warning-modal__title">{t("tracker.unSavedModalTitle")}</h5>
      <Text className="warning-modal__text">
        {t("tracker.unSavedDescription")}
      </Text>
      <div className="warning-modal__footer">
        <PrimaryButton
          colorScheme="blue"
          label={t("tracker.cancel")}
          onClick={showPreviousModal}
        />
        <SecondaryButton
          colorScheme="red"
          label={t("tracker.confirmDiscard")}
          onClick={clearDirty}
        />
      </div>
    </Modal>
  );
};

FormDirtyWarningModal.propTypes = {
  unSavedModalShown: PropTypes.bool,
  hideTrackerModals: PropTypes.func,
  showPreviousModal: PropTypes.func
};

export default FormDirtyWarningModal;
